import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import Reviews from "@/components/site/Reviews";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyChooseUs />
        <About />
        <FAQ />
        <Reviews />
        <Booking />
      </main>
      <Footer />
    </>
  );
}
